/* eslint-disable no-undef */
/**
 * NEVER INCLUDE THIS FILE IN THE PORTAL BUILD!
 */

const Col = require("./Col/config.json");
const Row = require("./Row/config.json");
const Section = require("./Section/config.json");
const Header = require("./Header/config.json");
const Heading = require("./Heading/config.json");
const Navbar = require("./Navbar/config.json");
const Footer = require("./Footer/config.json");
const Text = require("./Text/config.json");
const KPI = require("./KPI/config.json");
const Input = require("./Input/config.json");
const Search = require("./Search/config.json");
const Booking = require("./Booking/config.json");
const Content = require("./Content/config.json");
const PageTypeAdmin = require("./PageTypeAdmin/config.json");
const PageTypeViewTemplate = require("./PageTypeViewTemplate/config.json");
const PageTypeView = require("./PageTypeView/config.json");
const PageTypeForm = require("./PageTypeForm/config.json");
const PageTypeSubForm = require("./PageTypeSubForm/config.json");
const PageTypeDoc = require("./PageTypeDoc/config.json");
const Radio = require("./Radio/config.json");
const Checkbox = require("./Checkbox/config.json");
const Dropdown = require("./Dropdown/config.json");
const Panel = require("./Panel/config.json");
const Button = require("./Button/config.json");
const Error = require("./Error/config.json");
const Date = require("./Date/config.json");
const FormTab = require("./FormTab/config.json");
const Form = require("./Form/config.json");
const ProcessButtons = require("./ProcessButtons/config.json");
const Login = require("./Login/config.json");
const Tickets = require("./Tickets/config.json");
const Cards = require("./Cards/config.json");
const ProcessBar = require("./ProcessBar/config.json");
const Password = require("./Password/config.json");
const Table = require("./Table/config.json");
const SectionIndicator = require("./SectionIndicator/config.json");
const Chart = require("./Chart/config.json");
const FileUpload = require("./FileUpload/config.json");
const Articles = require("./Articles/config.json");
const Markdown = require("./Markdown/config.json");
const EffectTable = require("./EffectTable/config.json");
const GoogleMaps = require("./GoogleMaps/config.json");
const FacebookLogin = require("./FacebookLogin/config.json");
const OpenIdConnect = require("./OpenIdConnect/config.json");
const GrandId = require("./GrandId/config.json");
const Image = require("./Image/config.json");
const Todos = require("./Todos/config.json");
const Categories = require("./Categories/config.json");
const EffectList = require("./EffectList/config.json");
const PDF = require("./PDF/config.json");
const Summary = require("./Summary/config.json");
const Signature = require("./Signature/config.json");
const FormLabel = require("./FormLabel/config.json");
const Notifications = require("./Notifications/config.json");
const ConfirmBtns = require("./ConfirmBtns/config.json");
const Lookup = require("./Lookup/config.json");
const SAML = require("./SAML/config.json");
const Process = require("./Process/config.json");
const NotificationsPopup = require("./NotificationsPopup/config.json");
const ChildSelector = require("./ChildSelector/config.json");
const SecondGuardian = require("./SecondGuardian/config.json");
const InlineHTML = require("./InlineHTML/config.json");
const InputTable = require("./InputTable/config.json");
const ProcessList = require("./ProcessList/config.json");
const ResetPassword = require("./ResetPassword/config.json");
const Stop = require("./Stop/config.json");
const NotificationsHub = require("./NotificationsHub/config.json");
const GrandIdSignature = require("./GrandIdSignature/config.json");
const GRPSignature = require("./GRPSignature/config.json");
const OLMap = require("./OLMap/config.json");
const Profile = require("./Profile/config.json");
const Logout = require("./Logout/config.json");
const SignatureInfo = require("./SignatureInfo/config.json");
const EffectCard = require("./EffectCard/config.json");
const Clone = require("./Clone/config.json");
const EventBooking = require("./EventBooking/config.json");
const Effect = require("./Effect/config.json");
const QueueInfo = require("./QueueInfo/config.json");
const BankID = require("./BankID/config.json");
const BankIDSignature = require("./BankIDSignature/config.json");
const SwedbankPay = require("./SwedbankPay/config.json");
const PaymentStatus = require("./PaymentStatus/config.json");
const Vote = require("./Vote/config.json");
const FormTodo = require("./FormTodo/config.json");
const Location = require("./Location/config.json");
const RiskMatrix = require("./RiskMatrix/config.json");
const Repeat = require("./Repeat/config.json");
const Accordion = require("./Accordion/config.json");
const Receipt = require("./Receipt/config.json");
const FormCards = require("./FormCards/config.json");
const FormCreate = require("./FormCreate/config.json");
const StateGroups = require("./StateGroups/config.json");
const GroupSelector = require("./GroupSelector/config.json");
const IDPHub = require("./IDPHub/config.json");
const Datasheet = require("./Datasheet/config.json");
const Loader = require("./Loader/config.json");
const CRUD = require("./CRUD/config.json");
const ProcessOverview = require("./ProcessOverview/config.json");
const LinkIcons = require("./LinkIcons/config.json");
const RadioIcons = require("./RadioIcons/config.json");

module.exports = {
  Col,
  Row,
  Header,
  Navbar,
  Heading,
  Footer,
  Text,
  KPI,
  Input,
  Search,
  Booking,
  Content,
  Section,
  PageTypeAdmin,
  PageTypeViewTemplate,
  PageTypeSubForm,
  PageTypeForm,
  PageTypeDoc,
  Radio,
  Checkbox,
  Dropdown,
  Panel,
  PageTypeView,
  Button,
  Error,
  Date,
  FormTab,
  Form,
  ProcessButtons,
  Login,
  Tickets,
  Cards,
  ProcessBar,
  Password,
  Table,
  SectionIndicator,
  Chart,
  FileUpload,
  Articles,
  Markdown,
  EffectTable,
  GoogleMaps,
  FacebookLogin,
  OpenIdConnect,
  GrandId,
  Image,
  Todos,
  Categories,
  EffectList,
  PDF,
  Summary,
  Signature,
  FormLabel,
  Notifications,
  ConfirmBtns,
  Lookup,
  SAML,
  Process,
  NotificationsPopup,
  ChildSelector,
  SecondGuardian,
  InlineHTML,
  InputTable,
  ProcessList,
  Stop,
  NotificationsHub,
  GrandIdSignature,
  GRPSignature,
  OLMap,
  Profile,
  Logout,
  SignatureInfo,
  EffectCard,
  Clone,
  EventBooking,
  Effect,
  QueueInfo,
  BankID,
  BankIDSignature,
  SwedbankPay,
  ResetPassword,
  PaymentStatus,
  Vote,
  FormTodo,
  Location,
  RiskMatrix,
  Repeat,
  Accordion,
  Receipt,
  FormCards,
  FormCreate,
  StateGroups,
  GroupSelector,
  IDPHub,
  Datasheet,
  Loader,
  CRUD,
  ProcessOverview,
  LinkIcons,
  RadioIcons,
};
